import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { AppraiserStore } from '../store/appraiserStore';

export const useAppraiserStore = () =>
  useContext<{
    appraiserStore: AppraiserStore;
  }>(StoreContext);
